interface IntervalVisualizationLoadingOptions {
  hasReadyScope: boolean
  isQueryEnabled: boolean
  isQueryLoading: boolean
  isScopeLoading: boolean
  rangeIsValid: boolean
}

export const isIntervalVisualizationLoading = ({
  hasReadyScope,
  isQueryEnabled,
  isQueryLoading,
  isScopeLoading,
  rangeIsValid,
}: IntervalVisualizationLoadingOptions): boolean =>
  isScopeLoading ||
  (hasReadyScope && !rangeIsValid) ||
  (isQueryEnabled && isQueryLoading)
